import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
const TraderTime = ({ startTime }: { startTime: number }) => {
	const { t } = useTranslation();
	const getDaysElapsed = (startTime: Date): number => {
		const startDate = new Date(startTime);
		const currentDate = new Date();
		const timeDifference = currentDate.getTime() - startDate.getTime();
		const daysElapsed = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
		return daysElapsed;
	};

	const daysElapsed = getDaysElapsed(new Date(startTime));
	return (
		<>
			<Box
				flex={1}
				minWidth="200px"
				maxWidth="376px"
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
					padding: "16px",
					borderRadius: "8px",
					margin: "8px",
				}}
				className="trader-credits-to-be-paid"
			>
				<Typography variant="body1" fontSize="24px">
					{t("trader.days_active")}
				</Typography>
				<Typography variant="body1" fontSize="40px" fontWeight="bold">
					{daysElapsed}
				</Typography>
			</Box>
		</>
	);
};

export default TraderTime;
